import React, { useEffect, useState } from "react";
import DashboardLayout from "../components/DashboardLayout";
import api from "../lib/api";
import { FileText, Download } from "lucide-react";
import { toast, Toaster } from "sonner";

export default function Files() {
  const [items, setItems] = useState([]);

  useEffect(() => { (async () => {
    const { data } = await api.get("/files"); setItems(data);
  })(); }, []);

  const download = async (f) => {
    try {
      const { data } = await api.get(`/files/${f.file_id}`);
      const bin = atob(data.content_b64);
      const arr = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
      const blob = new Blob([arr], { type: data.mime });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a"); a.href = url; a.download = data.filename; a.click();
      URL.revokeObjectURL(url);
    } catch (e) { toast.error("Download failed"); }
  };

  return (
    <DashboardLayout>
      <Toaster position="top-right" richColors />
      <div className="mb-8">
        <div className="text-xs uppercase tracking-[0.2em] text-zinc-500">File Vault</div>
        <h1 className="font-display text-3xl font-black tracking-tighter">Saved documents</h1>
        <p className="text-sm text-zinc-600 mt-2">Shipping labels, commercial invoices, and manifests for every booking.</p>
      </div>

      {items.length === 0 ? (
        <div className="py-16 text-center border border-zinc-200 rounded-sm bg-white">
          <FileText size={32} className="mx-auto text-zinc-300" />
          <div className="mt-3 text-zinc-500 text-sm">No files yet. Book a shipment to generate labels.</div>
        </div>
      ) : (
        <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-4">
          {items.map((f) => (
            <div key={f.file_id} className="bg-white border border-zinc-200 rounded-sm p-5 hover:shadow-md transition-shadow" data-testid={`file-${f.file_id}`}>
              <FileText size={28} className="brand-text" />
              <div className="mt-3 text-xs uppercase tracking-wider text-zinc-500">{f.type}</div>
              <div className="font-mono-plex text-sm truncate mt-1">{f.filename}</div>
              <div className="text-xs text-zinc-500 mt-1">{(f.size / 1024).toFixed(1)} KB · {new Date(f.created_at).toLocaleDateString()}</div>
              <button data-testid={`download-file-${f.file_id}`} onClick={() => download(f)} className="mt-4 w-full brand-bg text-white text-xs px-3 py-2 rounded-sm hover:opacity-90 flex items-center justify-center gap-2">
                <Download size={12} /> Download
              </button>
            </div>
          ))}
        </div>
      )}
    </DashboardLayout>
  );
}
